// removed by extract-text-webpack-plugin
module.exports = {"vpNoMediaCollected":"vpNoMediaCollected___27OK4"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpNoMediaCollected/VpNoMediaCollected.module.less
// module id = 3182
// module chunks = 33